import PropTypes from 'prop-types';
import { useMemo } from 'react';
import MultiSelectAutocompleteFilter from '../../../../Filters/MultiSelectAutocompleteFilter';
import buildTourFilterOptions from '../../../../../helpers/buildTourFilterOptions';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourActivityFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(() => {
    const activities = buildTourFilterOptions(filters?.activities, searchObj.activities);
    if (activities.length === 0) {
      return [];
    }
    return [{ label: 'Activities', value: 'activities', suggests: activities }];
  }, [filters, searchObj.activities]);

  if (options.length === 0) {
    return <></>;
  }

  const values = (searchObj.activities || []).map((activity) => ({
    value: activity,
    label: activity,
  }));

  return (
    <MultiSelectAutocompleteFilter
      label="Activity"
      options={options}
      values={values}
      onChange={(selected) => applyFilter({ activities: (selected || []).map((s) => s.value) })}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      filterMaxWidthClass="max-w-full"
      freeSolo={false}
      openOnFocus
    />
  );
};

TourActivityFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourActivityFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourActivityFilter;
